






























































































































import { FFormStep, FRadioGroup, FRadioGroupField, FIcon, FMessageBox } from '@fkui/vue';
import Vue from 'vue';
import { ValidationService } from '@fkui/logic';
import { EventBus } from '@/services/MainService/event-bus';
import DataArrayItem from './DataArrayItem';
import BtNumberField from './BtNumberField.vue';
import FkRichtext from 'fk-vue-richtext';

const MAX_AGE = 64;
const MIN_AGE = 18;
const MAX_AGE_SAMBO = 99;
const MIN_AGE_SAMBO = 15;

export default Vue.extend({
    name: 'BtSambo',
    components: {
        FRadioGroup,
        FRadioGroupField,
        FFormStep,
        FIcon,
        FMessageBox,
        BtNumberField,
        FkRichtext,
    },
    props: {
        // eslint-disable-next-line vue/require-prop-types
        dataArray: {
            default: () => {
                return [] as string[];
            },
        },
    },
    data() {
        return {
            id: 'btSambo',
            radioPartnerSelection: '',
            alder: '',
            alderSambo: '',
            picked: '',
            MAX_AGE: MAX_AGE,
            validation: {
                required: { errorMessage: this.$t('btp.preliminar.berakning.omdig.fel.dinalder') },
                minValue: { minValue: MIN_AGE, errorMessage: this.$t('btp.preliminar.berakning.omdig.fel.alderforlag') },
                maxValue: { maxValue: MAX_AGE, errorMessage: this.$t('btp.preliminar.berakning.omdig.fel.alderforhog') },
            },
            validationSambo: {
                required: { errorMessage: this.$t('btp.preliminar.berakning.omdig.fel.samboalder') },
                minValue: { minValue: MIN_AGE_SAMBO, errorMessage: this.$t('btp.preliminar.berakning.omdig.fel.rattalder') },
                maxValue: { maxValue: MAX_AGE_SAMBO },
            },
        };
    },
    computed: {
        isNotWithinRange(): boolean {
            return parseInt(this.alder, 10) < MIN_AGE || parseInt(this.alder, 10) > MAX_AGE;
        },
    },
    methods: {
        toggleErrorMessages(): void {
            const errorList = this.$el.querySelector('.error-list') as HTMLElement;
            if (errorList) {
                if (this.isNotWithinRange) {
                    errorList.style.display = 'none';
                } else {
                    errorList.style.display = 'block';
                }
            }
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        openContainer(toggleIsOpen: any): void {
            this.emitChangeOmDig();
            toggleIsOpen();
        },
        emitChangeOmDig() {
            this.$emit('on-change-emit-omdig');
        },
        onClickRadio(radioId: string): void {
            this.emitChangeOmDig();
            EventBus.$emit('sambo-radio', this.radioPartnerSelection === 'radio-partner-no');
            this.picked = radioId;
            this.onSubmitStep();
        },
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        onSubmit(toggleIsOpen: any): void {
            toggleIsOpen();
            this.onSubmitStep();
            ValidationService.validateAllElements('btSambo');
            this.$nextTick(() => {
                this.toggleErrorMessages();
            });
        },
        onSubmitStep() {
            const dataArray: DataArrayItem[] = [];
            if (this.picked === 'radio-partner-no') {
                dataArray.push(
                    {
                        label: this.$t('btp.preliminar.berakning.omdig.etikett.sambopartner'),
                        itemId: 'btp.preliminar.berakning.omdig.etikett.sambopartner',
                        value: this.$t('btp.preliminar.berakning.omdig.etikett.sambopartner.ensamboende'),
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omdig.etikett.dinalder'),
                        itemId: 'btp.preliminar.berakning.omdig.etikett.dinalder',
                        value: this.alder,
                    },
                );
            } else if (this.picked === 'radio-partner-yes') {
                dataArray.push(
                    {
                        label: this.$t('btp.preliminar.berakning.omdig.etikett.sambopartner'),
                        itemId: 'btp.preliminar.berakning.omdig.etikett.sambopartner',
                        value: this.$t('btp.preliminar.berakning.omdig.etikett.sambopartner.sammanboende'),
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omdig.etikett.dinalder'),
                        itemId: 'btp.preliminar.berakning.omdig.etikett.dinalder',
                        value: this.alder,
                    },
                    {
                        label: this.$t('btp.preliminar.berakning.omdig.etikett.samboalder'),
                        itemId: 'btp.preliminar.berakning.omdig.etikett.samboalder',
                        value: this.alderSambo,
                    },
                );
            }
            this.$root.$emit('on-submit-emit-omdig', dataArray, 'btSambo');
            this.$emit('on-submit-emit-omdig', dataArray, 'btSambo');
        },
    },
});
